import { gql } from '@apollo/client'

export const GET_DISPLAY_AUDITS_PICOS_COMPLIANCE = gql`
  query DisplayAuditsPicosCompliance(
    $input: DisplayAuditsPicosComplianceInput!
  ) {
    displayAuditsPicosCompliance(input: $input) {
      displayAuditId
      storeAuditId
      compliancePercentage
      priorityId
    }
  }
`
